import React from 'react';

import { Content } from './Content.js';
import PeopleListCard from './PeopleListCard.jsx';
import PeopleListNav from './PeopleListNav.jsx';

export default class PeopleList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      'people': this.props.people,
      'selected': 'leaders'
    };

    this.changeTab = this.changeTab.bind(this);
  }

  changeTab(newList, selected) {
    this.setState({
      'people': newList,
      'selected': selected
    });

    this.props.actions.populate(newList);
  }

  render() {
    return (
      <div className="PeopleList row">
        <PeopleListNav changeTab={this.changeTab} selected={this.state.selected} />
        {/* /<h3 className="">{Content.people[this.state.selected].title}</h3> */}
        <div className="cards">
          {
            this.state.people.map((person, index) => (
              <PeopleListCard key={ index } person={ person } index={index} actions={this.props.actions} />
            ))
          }
        </div>
      </div>
    );
  }

};
